var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComparePagesDynamic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 74 74",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M22.279,52.717H4.428A2.43,2.43,0,0,1,2,50.29V4.428A2.43,2.43,0,0,1,4.428,2H50.29a2.43,2.43,0,0,1,2.427,2.428V22.279a1,1,0,0,1-2,0V4.428A.434.434,0,0,0,50.29,4H4.428A.428.428,0,0,0,4,4.428V50.29a.434.434,0,0,0,.428.427H22.279a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M51.716,16H3a1,1,0,0,1,0-2H51.716a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M46.439,10H26.2a1,1,0,0,1,0-2H46.439a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M9.448,10H8.276a1,1,0,0,1,0-2H9.448a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M15.065,10H13.894a1,1,0,1,1,0-2h1.171a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M20.683,10H19.512a1,1,0,0,1,0-2h1.171a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M53.07,72H50.14a1,1,0,0,1,0-2h2.93a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M69.57,72H60.08a1,1,0,1,1,0-2h9.49a.431.431,0,0,0,.43-.43V23.72a.441.441,0,0,0-.43-.44H23.72a.445.445,0,0,0-.44.44V69.57a.441.441,0,0,0,.44.43h9.49a1,1,0,1,1,0,2H23.72a2.438,2.438,0,0,1-2.44-2.43V23.72a2.443,2.443,0,0,1,2.44-2.44H69.57A2.438,2.438,0,0,1,72,23.72V69.57A2.433,2.433,0,0,1,69.57,72Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M43.14,72H40.2a1,1,0,0,1,0-2h2.94a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M71,35.283H22.284a1,1,0,0,1,0-2H71a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M65.724,29.283H45.48a1,1,0,0,1,0-2H65.724a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M28.732,29.283H27.561a1,1,0,0,1,0-2h1.171a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M34.349,29.283H33.178a1,1,0,0,1,0-2h1.171a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M39.967,29.283H38.8a1,1,0,0,1,0-2h1.172a1,1,0,0,1,0,2Z",
    fill: "current",
    "data-original": "#000000",
    style: {},
    className: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparePagesDynamic);
export default __webpack_public_path__ + "static/media/compare-pages-dynamic.212259d6d9863148a657670912a3a470.svg";
export { ForwardRef as ReactComponent };